import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { environment } from '../../../../environments/environment';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { IAppointment } from '../../../models/appointment.interface';
import { CVA_CONSTANTS, TAB } from '../../../util/constants';
import { RecordTranscriptionComponent } from "../../record-transcription/record-transcription.component";
import { SoapServiceService } from '../../../services/soap-service/soap-service.service';
import { PractitionerService } from '../../../services/practitioner/practitioner.service';
import { UserPreferenceService } from '../../../services/user-preferences/user-preference.service';
import { CustomTemplateService } from '../../../services/custom-template/custom-template.service';
import { concatMap, delay, filter, forkJoin, of, Subject, takeUntil } from 'rxjs';
import { ITab, TemplateListing } from '../../../models/manage-template.interface';
import { Identifier, TAB_ITEM } from '../../../models/template.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SectionType } from '../../../util/soap-config.constants';
import { VerticalUserInputs } from '../../../models/dictation.interface';
import { CVANotificationService } from '../../../services/cva-notification/cva-notification.service';
import { NotificationClassEnum } from '../../../models/notification-class.enum';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { IRecommendations, RecommendationType } from '../../../models/consultation-recommendation.model';
import { ConsultationRecommendationService } from '../../../services/consultation-recommendation/consultation-recommendation.service';
import { UserPreferencePayload } from '../../../models/soap-config.interface';
@Component({
  standalone: false,
  selector: 'cva-consultation-tab-view',
  templateUrl: './consultation-tab-view.component.html',
  styleUrl: './consultation-tab-view.component.scss',
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0
      })),
      transition('void <=> *', animate(300)),
    ]),
  ],

})
export class ConsultationTabViewComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() appointment!: IAppointment;
  @Input() selectedTab: TAB = TAB.TRANSCRIPTION;
  @Input() reaload: boolean = false;
  @Output() recordingStateChange = new EventEmitter<boolean>();
  @Output() notesApproved = new EventEmitter<void>();
  @ViewChild('tab2', { static: false }) recordTranscriptionComponent!: RecordTranscriptionComponent;
  @ViewChild(MatTabGroup, { static: false }) tabGroup!: MatTabGroup;
  Tab = TAB;
  tabs: ITab[] = [];
  TAB_ITEM = TAB_ITEM;
  consultationForm: FormGroup;

  disableAllApproves: boolean = false;
  isVisible: boolean = false;
  cvaUI_url = environment.cvaUI_url;
  recordedTranscription: string = '';
  templateType!: string;
  isSOAPTabDisable = true;
  selectedTemplate!: TemplateListing;
  noteTemplateListing!: TemplateListing[];
  isLIC = localStorage.getItem('isLIC') === 'true';
  tabItemCounter = new Map<string, number>();
  selectedIndex: number = 0;
  isTranscriptionEditable = true;
  vitals: VerticalUserInputs[] = [];
  disableAllTabs = false;

  isSmallScreen = false;

  isDrawerIconBlinking: Record<RecommendationType, boolean> = {
    [RecommendationType.Task]: false,
    [RecommendationType.Classification]: false,
    [RecommendationType.Medication]: false,
    [RecommendationType.ACC_ELIGIBILITY]: false,
  };

  drawerMode: 'over' | 'side' = 'side';

  selectedRecommendation: RecommendationType | null = null;
  recommendationType = RecommendationType;
  recommendations = environment.RECOMMENDATIONS;

  liveTranscriptionEnabled: boolean | null = null;

  private readonly _unsubscribeAll = new Subject<void>();

  private getCurrentAppointmentDraft() {
    const savedDraft = this.soapServiceService.getAppointmentAndDraftedNotes();
    if (!savedDraft?.referenceId || !this.appointment?.referenceId) {
      return null;
    }
    return savedDraft.referenceId === this.appointment.referenceId ? savedDraft : null;
  }

  constructor(private readonly soapServiceService: SoapServiceService,
    private readonly practitionerService: PractitionerService,
    private readonly fb: FormBuilder,
    private readonly customTemplateService: CustomTemplateService,
    private readonly userPreferenceService: UserPreferenceService,
    private readonly cvaNotificationService: CVANotificationService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly consultationRecommendationService: ConsultationRecommendationService

  ) { }

  ngOnInit(): void {
    if (this.reaload) {
      this.deleteTabs();
    }
    const selectedAppointment = this.getCurrentAppointmentDraft();
    if (!localStorage.getItem('isLIC')) {
      this.recordedTranscription = selectedAppointment?.referenceId ?
        selectedAppointment.transcription :
        this.appointment.transcription;
    } else {
      this.recordedTranscription = this.appointment.transcription || '';
    }
    if (this.appointment?.transcription?.trim() && this.appointment?.tabsData?.length > 0) {
      const { tabs, tabData } = this.unmergeTabs(this.appointment?.tabsData);
      // generate tabs
      localStorage.setItem('tabs', JSON.stringify(tabs));
      // generate form controls for tabs
      localStorage.setItem('consultationForm', JSON.stringify(tabData));
    }
    this.setVitalsTableParams()
    this.getTemplateSetting();
    this.initConsultationForm();
    this.initTabs(false);

    this.initScreenSizeObserver();
    this.listenDrawerData();
    this.listenVitalsUpdated();

    //set the recommendations
    this.consultationRecommendationService
      .setRecommendations(this.appointment?.recommendations || {} as IRecommendations)
  }

  ngAfterViewInit() {
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = this.selectedIndex;
    }
    setTimeout(() => {
      this.isVisible = true;
    }, 250);
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  unmergeTabs(mergedTabs: any) {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const tabs = mergedTabs.map(({ content, userInput, ...tab }: any) => {
      console.log(userInput, content);
      return tab;
    });
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const tabData: any = {};
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    mergedTabs.forEach((tab: any) => {
      if (tab.content) {
        tabData[tab.controlName] = tab.content;
      }
      if (tab.userInput?.length) {
        tabData[`${tab.controlName}_user_input`] = tab.userInput;
      }
    });

    return { tabs, tabData };
  }

  onTranscriptionUpdate(newText: string) {
    this.recordedTranscription = newText;
  }

  onRecordingStateChange(isRecording: boolean): void {
    this.recordingStateChange.emit(isRecording);
  }

  initConsultationForm() {
    this.consultationForm = this.fb.group({
      sessionTitle: ['', [Validators.pattern(CVA_CONSTANTS.REGEX.titleInput)]],
      patientName: ['', Validators.pattern(CVA_CONSTANTS.REGEX.patientName)],
      transcription: [{ value: '', disabled: !this.isTranscriptionEditable }]
    });

    const temp = localStorage.getItem("consultationForm");
    this.disableAllApproves = localStorage.getItem("disableAllApproves") === 'true';
    if (temp) {
      const consultationForm = JSON.parse(temp);
      for (const key in consultationForm) {
        if (["sessionTitle", "patientName", "transcription"].indexOf(key) > -1) {
          this.consultationForm.setValue({
            sessionTitle: consultationForm.sessionTitle,
            patientName: consultationForm.patientName,
            transcription: consultationForm.transcription
          });
        } else {
          this.addControl(
            key,
            consultationForm[key],
            false
          )
        }
      }
    }
  }

  setVitalsTableParams() {
    this.vitals = [];
    this.userPreferenceService.getSoapSettings(
      this.appointment.practitioner.referenceId,
      CVA_CONSTANTS.USER_SETTING_TYPES.VITALS_MAPPING
    )
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        next: (vitalMappingSettings: any) => {
          if (vitalMappingSettings.preference?.forEach) {
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            vitalMappingSettings.preference.forEach((vital: any) => {
              // eslint-disable-next-line  @typescript-eslint/no-explicit-any
              const comp: any = vital?.screeningTerm?.component[0];
              const vitalData: VerticalUserInputs = {
                title: vital.cvaVital,
                type: SectionType.text,
                unit: comp?.code?.text,
                value: ""
              }
              if (vital?.screeningTerm?.component.length === 2) {
                // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                const comp1: any = vital?.screeningTerm?.component[1];
                vitalData.unit = `${comp?.code?.text}/${comp1?.code?.text}`
              }
              if (comp?.valueCodeableConcept?.coding) {
                vitalData.data = [];
                // eslint-disable-next-line  no-unsafe-optional-chaining
                for (const d of comp?.valueCodeableConcept?.coding) {
                  vitalData.data.push(d.display)
                }
                vitalData.type = SectionType.dropdown;
              }
              if (!this.vitals.some((item => item.title === vitalData.title))) {
                this.vitals.push(vitalData);
              }
            });
            this.vitals.sort((a, b) => a.title.localeCompare(b.title));
          }
        },
        error: () => {
          console.log(CVA_CONSTANTS.MESSAGE.VITALS_MAPPING_FETCH_ERROR);
          this.cvaNotificationService.showNotification(CVA_CONSTANTS.MESSAGE.VITALS_MAPPING_FETCH_ERROR, NotificationClassEnum.ERROR);
        }
      });
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  addControl(controlName: string, initialValue: any, isDisabled: boolean = false) {
    const newControl = new FormControl({ value: initialValue, disabled: isDisabled });
    this.consultationForm.addControl(controlName, newControl);
  }

  getFormControl(controlName: string): FormControl {
    const control = this.consultationForm?.get(controlName);
    if (control instanceof FormControl) {
      return control;
    }

    const fallbackValue = controlName.endsWith('_user_input') ? [] : '';
    const fallbackControl = new FormControl(fallbackValue);
    this.consultationForm?.addControl(controlName, fallbackControl);
    return fallbackControl;
  }

  handleApprove() {
    this.disableAllApproves = true;
    // Approval clears the generated note draft, but the generated
    // classifications, prescriptions and tasks must remain visible.
    this.deleteTabs(false);
    this.notesApproved.emit();
  }

  initTabs(resetHard: boolean) {
    if (resetHard) {
      this.showTranscriptTabOnly();
    } else {
      const tabs = localStorage.getItem("tabs");
      if (tabs?.length) {
        this.tabs = JSON.parse(tabs);
      } else {
        this.showTranscriptTabOnly();
      }
      if (this.tabs?.length) {
        this.tabs.forEach((tab => this.incrementTabItemCount(tab.identifier)));
      }
    }
    this.selectedIndex = 0;
  }

  showTranscriptTabOnly() {
    this.tabs = [
      {
        title: TAB_ITEM.TRANSCRIPT,
        controlName: Identifier.TRANSCRIPT,
        isEditable: this.isTranscriptionEditable,
        identifier: Identifier.TRANSCRIPT
      }
    ];
  }

  addNewTab(newTab: ITab) {
    let content: string;
    const currentCount = this.getTabItemCount(newTab.identifier);
    const selectedAppointment = this.getCurrentAppointmentDraft();
    if (selectedAppointment?.templateType && Object.keys(selectedAppointment?.notes || {}).length) {
      content = selectedAppointment?.notes[selectedAppointment?.templateType].notes;
    } else {
      return;
    }
    if (!currentCount) {
      //set a new item into the mapper
      this.setTabItemCount(newTab.identifier);
    } else {
      //increment the counter and append the last counter as suffix      
      this.incrementTabItemCount(newTab.identifier);
      newTab.suffix = currentCount;
      newTab.controlName += `_${currentCount}`;
    }

    this.tabs.push(newTab);

    //add new control
    this.addControl(
      newTab.controlName,
      content,
      !newTab.isEditable
    )

    if (Object.keys(selectedAppointment?.notes[selectedAppointment?.templateType].userInputs || []).length) {
      const userInputContent = selectedAppointment?.notes[selectedAppointment?.templateType].userInputs;
      this.addControl(
        newTab.controlName + '_user_input',
        userInputContent,
        !newTab.isEditable
      )
    }

    this.selectedIndex = this.tabs.length - 1;
    this.tabGroup.selectedIndex = this.selectedIndex;

    this.persistValues();
  }

  setTabItemCount(item: string, count: number = 1): void {
    this.tabItemCounter.set(item, count);
  }

  getTabItemCount(item: string): number {
    return this.tabItemCounter.get(item) ?? 0;
  }

  incrementTabItemCount(item: string): void {
    this.tabItemCounter.set(item, (this.tabItemCounter.get(item) ?? 0) + 1);
  }

  onTabChanged(event: MatTabChangeEvent) {
    this.selectedIndex = event.index;
  }

  refreshTemplates() {
    this.getTemplateSetting();
    const tabs = localStorage.getItem("tabs");
    if (tabs?.length) {
      this.tabs = JSON.parse(tabs);
    }
    this.selectedIndex = 0;
  }

  trackByFn(item: ITab) {
    return item.identifier + item.suffix;
  }

  hasDefaultTemplate() {
    return this.tabs.some(tab => tab.identifier === this.templateType);
  }

  getTemplateSetting() {
    const referenceId = this.practitionerService?.loggedInPractitioner?.referenceId ?? history.state?.practitioner?.referenceId;
    if (referenceId) {
      const soapSettingsResp = this.userPreferenceService.getSoapSettings(referenceId, CVA_CONSTANTS.CONSTS.template_type);
      const noteTemplateListingResp = this.customTemplateService.getData();
      const preferences = this.userPreferenceService.getSoapSettings(referenceId, CVA_CONSTANTS.CONSTS.user_preference);

      forkJoin([soapSettingsResp, noteTemplateListingResp, preferences])
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (responses) => {
            this.noteTemplateListing = responses[1].response;
            this.setTemplateType(responses[0]);
            const preference = responses[2].preference as UserPreferencePayload;
            this.liveTranscriptionEnabled = preference?.show_live_transcription || false;
          },
          error: (error) => {
            this.liveTranscriptionEnabled = false;
            console.error('Error occurred:', error);
          }
        }
        );
    }
  }

  getOnlyTemplateSetting() {
    const referenceId = this.practitionerService?.loggedInPractitioner?.referenceId ?? history.state?.practitioner?.referenceId;
    if (referenceId) {
      this.userPreferenceService.getSoapSettings(referenceId, CVA_CONSTANTS.CONSTS.template_type)
        .pipe(takeUntil(this._unsubscribeAll))
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        .subscribe((res: any) => {
          const result = this.soapServiceService.getTemplate(res?.preference?.templateType, this.noteTemplateListing);
          if (result) {
            this.templateType = result.templateType;
          }
        })
    }
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any  
  setTemplateType(data: any): void {
    const requestedTemplateType = data?.preference?.templateType;

    const result = this.soapServiceService.getTemplate(
      requestedTemplateType,
      this.noteTemplateListing
    );

    if (!result) {
      return;
    }

    this.templateType = result.templateType;
    this.selectedTemplate = result.selectedTemplate;

    if (requestedTemplateType === this.templateType) {
      const selectedAppointment = this.getCurrentAppointmentDraft();

      const templateNotes =
        selectedAppointment?.templateType === this.templateType
          ? selectedAppointment?.notes?.[this.templateType]?.notes
          : undefined;

      this.isSOAPTabDisable = Object.keys(templateNotes ?? {}).length > 0;
    } else {
      this.isSOAPTabDisable = true;
    }

    this.getOnlyTemplateSetting();
  }


  deleteTabs(clearRecommendations = true) {
    localStorage.removeItem("tabs");
    localStorage.removeItem("consultationForm");
    localStorage.removeItem("disableAllApproves");
    this.soapServiceService.removeAppointmentAndDraftedNotes();
    if (clearRecommendations) {
      this.consultationRecommendationService.clearAllRecommendations();
    }
  }
  persistValues() {
    localStorage.setItem("tabs", JSON.stringify(this.tabs));
    localStorage.setItem("consultationForm", JSON.stringify(this.consultationForm.value));
    localStorage.setItem("disableAllApproves", JSON.stringify(this.disableAllApproves));
  }

  toggleTabsDisable(disable: boolean) {
    this.disableAllTabs = disable;
  }

  initScreenSizeObserver() {
    this.breakpointObserver.observe([
      Breakpoints.Small,
      Breakpoints.XSmall
    ])
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(result => {
        this.isSmallScreen = result.matches;

        if (this.isSmallScreen) {
          this.selectedRecommendation = null;
          return;
        }
        //show the tasks only for big screen and have notes generated
        if (!this.isSmallScreen && this.tabs.length > 1) {
          if (environment.RECOMMENDATIONS.MEDICATIONS) {
            this.toggleDrawer(RecommendationType.Medication);
          } else if (environment.RECOMMENDATIONS.CLASSIFICATIONS) {
            this.toggleDrawer(RecommendationType.Classification);
          } else if (environment.RECOMMENDATIONS.TASKS) {
            this.toggleDrawer(RecommendationType.Task);
          } else if (environment.RECOMMENDATIONS.ACC_ELIGIBILITY) {
            this.toggleDrawer(RecommendationType.ACC_ELIGIBILITY);
          }
        }

      });
  }

  listenVitalsUpdated() {
    this.soapServiceService.vitalsUpdated$
      .pipe(
        filter((update) => update.appointmentRefId === this.appointment.referenceId),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe((update) => {
        // Only update the LAST tab matching the identifier — that is the newly generated one.
        // Updating all matching tabs would overwrite user-edited vitals in existing tabs.
        const matchingTabs = this.tabs.filter(tab => tab.identifier === update.identifier);
        const latestTab = matchingTabs[matchingTabs.length - 1];

        if (!latestTab) return;

        const controlName = latestTab.controlName + '_user_input';
        const control = this.getFormControl(controlName);

        if (control) {
          control.setValue(update.vitals);
        } else {
          this.addControl(controlName, update.vitals);
        }
        this.persistValues();
      });
  }

  listenDrawerData() {
    this.consultationRecommendationService.drawerTriggerObservable$
      .pipe(
        concatMap((type: RecommendationType) =>
          of(type).pipe(delay(30)) // handle each event 30ms apart
        ),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe((type: RecommendationType) => {
        this.handleDrawerTrigger(type);
      });
  }

  handleDrawerTrigger(type: RecommendationType) {
    const isDrawerOpen = this.isDrawerOpened();

    if (this.isSmallScreen) {
      if (this.selectedRecommendation !== type) {
        this.isDrawerIconBlinking[type] = true;
      }
      return;
    }

    if (!isDrawerOpen) {
      this.toggleDrawer(type, false);
    } else if (this.selectedRecommendation !== type) {
      this.isDrawerIconBlinking[type] = true;
    }
  }

  isDrawerOpened(): boolean {
    return this.selectedRecommendation !== null;
  }

  toggleDrawer(type: RecommendationType, checkToggle = true) {
    if (checkToggle) {
      if (this.selectedRecommendation === type) {
        // If same button clicked, close drawer
        this.selectedRecommendation = null;
        return;
      }
    }

    this.selectedRecommendation = type;
    this.isDrawerIconBlinking[type] = false;
  }

  ngOnDestroy(): void {
    if (this.disableAllApproves) {
      this.soapServiceService.removeAppointmentAndDraftedNotes();
    } else {
      this.persistValues();
      const selectedAppointment = this.getCurrentAppointmentDraft();
      const savedTranscription =
        this.recordTranscriptionComponent && typeof this.recordTranscriptionComponent.getTranscription === 'function'
          ? this.recordTranscriptionComponent.getTranscription()
          : this.recordedTranscription;
      if (selectedAppointment?.referenceId) {
        this.soapServiceService.setAppointmentAndDraftedNotes(
          selectedAppointment.referenceId,
          selectedAppointment.notes,
          savedTranscription,
          this.templateType
        );
      } else if (this.appointment?.referenceId) {
        this.soapServiceService.setAppointmentAndDraftedNotes(
          this.appointment.referenceId,
          {},
          savedTranscription,
          this.templateType
        );
      }
    }

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
